// extracted by mini-css-extract-plugin
export default {"server":"Server_server__aWhlx","deletePhraseButton":"Server_deletePhraseButton__gFttb","serverOpacity":"Server_serverOpacity__cHBLW","serverHidden":"Server_serverHidden__IIjgk"};